<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="Pt01">PART ONE<br/> <img alt="Image" src="images/img01_009.png"/><strong>voices <em>from the Storm</em></strong></h1>
<p class="indent"><a id="page_9"></a></p><a id="page_9">
</a><p class="indent"><a id="page_9"></a><a id="page_10"></a></p><a id="page_10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?2248ba4e